import React, { useState, useEffect, useCallback, useRef } from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Divider,
  Grid,
  MenuItem,
  TextField,
  Autocomplete,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import _ from "lodash";

//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import { useDropzone } from "react-dropzone";

import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";

import driverApi from "Services/Driver";

//
import { CUSTOM_CONSTANTS } from "Constants";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const UploadFiles = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { openDialog, handleClose, driverId, documentData } = props;

  const [filePath, setFilePath] = useState();

  const uploadFiles = (acceptedFiles) => {
    dispatch(showLoader("Loading please wait..."));

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setFilePath(res?.data?.data?.documentPath);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      showSnackbar({
        message: err?.data?.msg || "Failed to upload the file",
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
      });
      //console.log("profile image upload api", err);
    };
    const formData = new FormData();
    //console.log("acceptedFiles-->",acceptedFiles);
    acceptedFiles.forEach((file) => {
      formData.append("image", file); // Append the file
    });
    formData.append("document_id", documentData?.documentId);
    driverApi.updateDriverDocument(formData).then(onSuccess, onFailure);
  };

  // Max file size
  const maxFileSize = 5242880;
  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  // File length validator
  const fileLengthValidator = (file) => {
    if (file.size > maxFileSize) {
      alert(`File size is larger than ${formatBytes(maxFileSize)}`);
      return {
        code: "file-too-large",
        message: `File size is larger than ${formatBytes(maxFileSize)}`,
      };
    }
    return null;
  };

  // Dropzone props
  const { getRootProps, getInputProps, open } = useDropzone({
    noClick: true,
    noKeyboard: true,
    maxSize: formatBytes(maxFileSize),
    maxFiles: 1,
    accept: {
      "image/*": [".jpeg", ".jpg", ".png"],
      "application/pdf": [".pdf"],
    },
    validator: fileLengthValidator,
    onDrop: (acceptedFiles) => {
      let fileLength = acceptedFiles.map((file) => file.size);
      if (acceptedFiles && fileLength < maxFileSize) {
        uploadFiles(acceptedFiles);
      }
    },
    onDropRejected: (rejectedFiles) => {
      const invalidFormats = rejectedFiles.map((file) => file.type).join(", ");
      console.error(`Invalid file format(s): ${invalidFormats}`);
    },
  });

  const handleUploadFile = () => {
    dispatch(showLoader("Loading please wait..."));

    let validation = true;

    let data = {
      document_id: documentData?.documentId,
      documentDescription: documentData?.description,
      status: "ACCESSING",
    };

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "File uploaded successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        handleClose();
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      showSnackbar({
        message: err?.data?.msg || "Error while upload the file",
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
      });
    };

    if (validation) {
      driverApi.updateDriverDocument({ ...data }).then(onSuccess, onFailure);
    }
  };

  useEffect(() => {
    //console.log("documentData?.filePath ", documentData?.file);

    setFilePath(documentData?.file);
  }, [openDialog]);

  return (
    <>
      <Dialog
        open={openDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        maxWidth={"md"}
        aria-describedby="dialog-box"
        className={classes.root}
      >
        <DialogTitle>
          <section className={classes.dialogTitleContainer}>
            <Typography variant="body1" className={classes.title}>
              Upload a file
            </Typography>
            <IconButton aria-label="close" onClick={handleClose}>
              <CloseIcon className={classes.closeIcon} />
            </IconButton>
          </section>
        </DialogTitle>
        <DialogContent>
          <div className={classes.uploadAreaWrapper}>
            <section
              {...getRootProps()}
              onClick={open}
              className={classes.fileUploadArea}
            >
              <input {...getInputProps()} />
              <div className={classes.fileUploadContentsStyle}>
                <div>
                  <div className={classes.fileIconWrapper}>
                    <InsertDriveFileOutlinedIcon
                      style={{ fontSize: "100px" }}
                    />
                    <div className={classes.uploadIconWrapper}>
                      <FileUploadOutlinedIcon />
                    </div>
                  </div>
                </div>
                <Typography variant="body1" style={{ marginTop: "10px" }}>
                  Drag and Drop Files Here or{" "}
                  <span style={{ textDecoration: "underline" }}>
                    Choose File
                  </span>
                </Typography>
              </div>
            </section>

            <div className={classes.formatInfoWrapper}>
              <Typography variant="body1" className={classes.supportInfo}>
                Supported formats PDF|JPEG|JPG
              </Typography>
              <Typography variant="body1" className={classes.fileSizeInfo}>
                Maximum file size: 5mb
              </Typography>
            </div>

            {filePath && (
              <div className={classes.previewDocumentWrapper}>
                <Typography>Preview Document</Typography>
                <iframe
                  title="Document Viewer"
                  src={filePath}
                  className={classes.documentViewerWrapper}
                ></iframe>
              </div>
            )}
          </div>
        </DialogContent>
        <Divider />
        <DialogActions>
          <section className={classes.dialogActions}>
            <section className={classes.closeBtn}>
              <Button onClick={handleClose} style={{ marginRight: "10px" }}>
                Close
              </Button>
            </section>
            <section className={classes.closeBtn}>
              <Button onClick={handleUploadFile}>Upload</Button>
            </section>
          </section>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UploadFiles;
